import { render, staticRenderFns } from "./ClosedZoneEdit.vue?vue&type=template&id=7482476c&"
import script from "./ClosedZoneEdit.vue?vue&type=script&lang=js&"
export * from "./ClosedZoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports